<ng-container *ngFor="let menuSection of navService.menu">

  <ng-container *ngIf="!menuSection.admin || user.currentUserRole.role === 'admin' || g">
    <div class="menu-item" *ngIf="menuSection.title">
      <div class="menu-content pt-6 pb-2">
        <span class="menu-section fs-8 ls-1 text-theme-primary">{{menuSection.title}}</span>
      </div>
    </div>

    <ng-container *ngIf="!menuSection.requireOnboard || (showMenu | async)">
      <ng-container *ngFor="let item of menuSection.items">

        <ng-container *ngIf="!item.children">
          <ng-container *ngTemplateOutlet="menuItem; context: {item: item}"></ng-container>
        </ng-container>

        <ng-container *ngIf="item.children">
          <ng-container *ngTemplateOutlet="menuItemWithChildren; context: {item: item}"></ng-container>
        </ng-container>

      </ng-container>
    </ng-container>

  </ng-container>

</ng-container>

<ng-template #menuItem let-item="item">

  <div class="menu-item">
    <a
      class="menu-link without-sub"
      [routerLink]="item.url"
      routerLinkActive="active"
    >
      <span class="menu-icon">
      <i *ngIf="item.icon && item.icon_type === 'font'"
        [class]="item.icon"
      ></i>
    </span>
      <span class="menu-title">{{item.title}}</span
      ></a>
  </div>

</ng-template>

<ng-template #menuItemWithChildren let-item="item">

  <div
    class="menu-item menu-accordion"
    data-kt-menu-trigger="click"
    routerLinkActive="here show"
  >
  <span class="menu-link"
  ><span class="menu-icon"
  ><span
    class="svg-icon svg-icon-2"
    data-inline="'./assets/media/icons/duotune/general/gen022.svg'"
  ></span></span
  ><span class="menu-title">{{item.title}}</span><span class="menu-arrow"></span
  ></span>
    <div class="menu-sub menu-sub-accordion" routerLinkActive="menu-active-bg">

      <ng-container *ngFor="let childItem of item.children">

        <ng-container *ngIf="!childItem.children">
          <ng-container *ngTemplateOutlet="menuItem; context: {item: childItem}"></ng-container>
        </ng-container>

        <ng-container *ngIf="childItem.children">
          <ng-container *ngTemplateOutlet="menuItemWithChildren; context: {item: childItem}"></ng-container>
        </ng-container>

      </ng-container>

    </div>
  </div>

</ng-template>
